export const formatAddressText = (
  addressSelector: string,
  address1: string,
): string => {
  const addressSelectorText = addressSelector ? `${addressSelector} - ` : '';

  return `${addressSelectorText}${address1}`;
};
